<template>
  <div>
    <v-stepper v-model="stepper">
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="pl-5 pr-5 pt-3">
            <v-row>
              <v-col  class="d-flex justify-start">
                <span style="color: #777; font-size: 14px; text-align: start">{{ messages[0] }}</span>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <v-btn
                  v-if="!actionWorking"
                  style="border-color: #fff;"
                  @click="cancelAction"
                  rounded
                  depressed
                  outlined
                  small
                  width="100"
                >Cancelar</v-btn>
              </v-col>

              <v-col cols="4">
                <v-btn
                  @click="stepper = 2"
                  :style="styleConfirmBtn"
                  dark
                  rounded
                  depressed
                  outlined
                  small
                  min-width="100"
                >Continuar</v-btn>
              </v-col>
              </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-card class="pl-5 pr-5 pt-3">
            <v-row>
              <v-col  class="d-flex justify-start">
                <span style="color: #777; font-size: 14px; text-align: start">{{ messages[1] }}</span>
              </v-col>
            </v-row>
            <div class="ma-auto">
              <v-text-field
                v-model="otp"
                single-line
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></v-text-field>
              <!-- <v-otp-input
                v-model="otp"
                type="number"
                :length="lengthOtp"
              ></v-otp-input> -->
              <v-snackbar
                v-model="snackbar"
                color="warning"
                :timeout="2000"
              >
                PIN Incorrecto
              </v-snackbar>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <v-btn
                  v-if="!actionWorking"
                  style="border-color: #fff;"
                  @click="cancelAction"
                  rounded
                  depressed
                  outlined
                  small
                  width="100"
                >Cancelar</v-btn>
              </v-col>

              <v-col cols="4">
                <v-btn
                  :disabled="!otp || otp.length !== lengthOtp"
                  @click="!actionWorking ? completeAction() : false"
                  :style="styleConfirmBtn"
                  dark
                  rounded
                  depressed
                  outlined
                  small
                  min-width="100" 
                >{{!actionWorking ? confirmBtn : ''}} <v-progress-circular v-if="actionWorking" color="white" :size="16" :width="2"  indeterminate ></v-progress-circular></v-btn>
              </v-col>
              </v-card-actions>

          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
export default {
  name: "DialogConfirmReset",
  data() {
    return {
      dialog: false,
      stepper: 1,
      otp: null,
      lengthOtp: 4,
      pass: 5546,
      snackbar: false
    };
  },
  props: {
    messages: Array,
    actionWorking :{
      type: Boolean,
      default: false,
    },
    confirmBtn :{
      type: String,
      default: "Aceptar",
    },
    styleConfirmBtn:{
      type: String,
      default: "background: #679940",
    }
  },
  computed: {},
  methods: {
    cancelAction(){
      this.$emit('close-dialog')
    },
    completeAction(){
      if (+this.otp === this.pass) this.$emit('complete-action')
      else this.snackbar = true
      },
  },
  beforeDestroy(){
    this.stepper = 1
    this.otp = null
  }
};
</script>

<style scoped></style>












              


// WEBPACK FOOTER //
// src/components/DialogConfirmReset.vue